export default {
  title: 'Report',
  tab: 'REPORT',
  label: {
    userName: 'User Name',
    resumeViewedCount: 'Resumes Viewed (AJINGA)',
    widgetResumeViewedCount: 'Resumes Viewed ({channel})',
    incomingResumeCount: 'Incoming Resumes',
    referralResumeCount: 'Shortlisted Resumes',
    interviewResumeCount: 'Interview Resumes',
    offeredResumeCount: 'Offer Resumes',
    userUsageDuration: 'User Usage',
    activeDays: 'Active Days',
    companyName: 'Company Name',
    startDate: 'Start Date',
    endDate: 'End Date',
    selectHr: 'Select Recruiter(s)',
    selectAllHr: 'All',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    last90Days: 'Last 90 Days',
    hour: '{hour}h',
    minute: '{minute}m'
  },
  btn: {
    export: 'Export',
    save: 'Save',
    checkAll: 'All'
  },
  message: {
    deleteFilterContent: 'Please confirm you would like to delete this user from the group.',
    deleteFilterTitle: 'Warning',
    deleteSearchGroupSuccess: 'Delete successfully',
    cancelDeleteSearchGroup: 'Cancelled',
    saveGroupTitle: 'Save to Group',
    saveGroupTip: 'Save to new group or update existing group',
    saveGroupContent: 'Save to new group',
    updateGroupContent: 'Update an existing group',
    saveGroupSuccess: 'Saved successfully',
    dateRangeTooLong: 'Oops, you can only select up to 90 days.'
  },
  companyExport: {
    title: 'Export Data',
    menu: 'Export Data'
  },
  exportApplyData: {
    title: 'Export Apply Data',
    menu: 'Export Apply Data'
  },
  hiringFunnelReport: {
    title: 'Current Pipeline Per Job',
    menu: 'Current Pipeline Per Job'
  },
  sourcingChannelReport: {
    title: 'Sourcing Channel Report',
    menu: 'Sourcing Channel Report'
  },
  customReferralReport: {
    title: 'Referral Balance Report',
    menu: 'Referral Balance Report'
  },
  userUsageReport: {
    title: 'User Usage Report',
    menu: 'User Usage Report'
  },
  potentialCandidateReport: {
    title: 'Lead/Prospect Candidate Report',
    menu: 'Lead/Prospect Candidate Report'
  },
  satisfactionSurveyHiringManagerReport: {
    title: 'Satisfaction Survey Hiring Manager Report',
    menu: 'Satisfaction Survey Hiring Manager Report'
  },
  satisfactionSurveyCandidateReport: {
    title: 'Satisfaction Survey Candidate Report',
    menu: 'Satisfaction Survey Candidate Report'
  },
  wechatTemplateMessageReportTotal: {
    title: 'WeChat Template Message Report - Total',
    menu: 'WeChat Template Message Report - Total'
  },
  wechatTemplateMessageReportDetail: {
    title: 'WeChat Template Message Report - Detail',
    menu: 'WeChat Template Message Report - Detail'
  },
  recruiterKpiDashboard: {
    title: 'Recruiter KPI Dashboard',
    menu: 'Recruiter KPI Dashboard'
  }
}
